import React, { useEffect } from 'react';

import { Box, Divider, Link, Stack, Tooltip, Typography, useTheme } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';

import { ImageAvatar } from 'components/Avatar';
import { ListCard } from 'components/Card';
import { Status as StatusComponent } from 'components/Status';
import { IconWrapper } from 'components/Icon';

import { isoToDateString } from 'utils/dateFormatter';

import { useAuth } from 'lib/auth';
import { paths } from 'routes';

const OWNER_TYPE_LABELS = {
  Intermediator: 'Intermediator',
  Framework: 'Framework Agreement',
  DPS: 'DPS',
  Direct: 'Direct',
};

export const ListItem = ({
  ad_id,
  headline,
  reference_number,
  status,
  last_day_to_respond,
  buyer_id,
  buyer_name,
  buyer_slug,
  buyer_hidden,
  hide_buyer,
  total_no_versions,
  buyer_logo_url,
  owner_type,
  adminView, // Accept adminView prop
}) => {
  const { account } = useAuth();
  const theme = useTheme();

  const detailsPath = adminView ? paths.adminJobAdsDetailsView(ad_id) : paths.myJobAdsDetailsView(ad_id);

  return (
    <ListCard>
      <ImageAvatar img={buyer_logo_url || ''} name={buyer_name || ''} anonymous={buyer_hidden} />
      <Stack flex={{ md: 2, xl: 4 }} sx={{pr:1}} justifyContent="center">
        <Link
          component={RouterLink}
          to={detailsPath}
          color="inherit"
        >
          <Stack direction={'row'} gap={1} alignItems="center">
            <Typography variant="body1" fontWeight={700}>
              {headline}
            </Typography>
            {hide_buyer && (
              <Tooltip title="Buyer is hidden">
                <Box display="flex">
                  <IconWrapper
                    icon="hidden"
                    sx={{
                      mt: -0.4,
                      svg: { stroke: theme.palette.text.secondary, color: theme.palette.text.secondary, strokeWidth: 1.5, width: 16, height: 16 },
                    }}
                    height={16}
                  />
                </Box>
              </Tooltip>
            )}
          </Stack>
        </Link>
        <Stack direction="row" gap={1}>
          <Typography variant="caption" fontWeight={600}>
            {reference_number}
          </Typography>
          {owner_type && (
            <>
              <Divider
                orientation="vertical"
                sx={{ borderColor: 'grey.500', height: 15, borderWidth: '1px' }}
              />
              <Typography variant="caption" fontWeight={600}>
                {OWNER_TYPE_LABELS[owner_type] || owner_type}
              </Typography>
            </>
          )}
          <Divider
            orientation="vertical"
            sx={{ borderColor: 'grey.500', height: 15, borderWidth: '1px' }}
          />
          <Typography variant="caption" color="text.primary" fontWeight={700}>
            <Link
              component={RouterLink}
              to={paths.public.companyPublicProfile("buyer", buyer_slug)}
              color="inherit"
            >
              {buyer_name}
            </Link> 
          </Typography>
        </Stack>
      </Stack>
      <Stack justifyContent="center" sx={{pr:1, width: 60}}>
        <Typography variant="caption" fontWeight={700}>
        Versions
        </Typography>
        <Link
          component={RouterLink}
          to={`${detailsPath}?tab=versions`}
          color="inherit"
        >
          <Typography variant="body2" fontWeight={700}>
            {total_no_versions}
          </Typography>
        </Link>
      </Stack>
      <Stack justifyContent="center" sx={{pr:1, width: 120}}>
        <Typography variant="caption" fontWeight={700}>
          Ad end date
        </Typography>
            
        <Typography variant="body2" fontWeight={700}>
          {isoToDateString(last_day_to_respond)}
        </Typography>
      </Stack>
      <StatusComponent status={status} additionalColor />
    </ListCard>
  );
};
